import { Component, inject, input, model, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { roleOrder } from '@vectronic/ui';
import { SnackbarService } from '@vectronic/util';
import { DatatableListWithActionsSettings } from '../../types/datatable-list-with-actions-settings';

@Component({
  selector: 'table-datatable-list-with-actions',
  templateUrl: './datatable-list-with-actions.component.html',
  styleUrls: ['./datatable-list-with-actions.component.scss'],
  imports: [MatIconModule, MatTooltipModule, MatButtonModule],
})
export class DatatableListWithActionsComponent {
  private snackbarService = inject(SnackbarService);

  settings = input(null, {
    transform: (settings: DatatableListWithActionsSettings | null) => {
      if (!settings.list) return { ...settings, list: undefined };

      const sortedList = [...settings.list].sort((a, b) => {
        const aOrder = roleOrder.get(a.role) ?? roleOrder.size;
        const bOrder = roleOrder.get(b.role) ?? roleOrder.size;
        return aOrder - bOrder;
      });

      return { ...settings, list: sortedList };
    },
  });

  readonly = input<boolean>();
  showMore = model<boolean>(false);
  compactMode = input.required<boolean>();
  horizontalList = input<boolean>(false);

  buttonClicked = output<{ type: 'edit' | 'delete' | 'add'; element: any }>();

  onToggleShowMore(event: MouseEvent) {
    event.stopPropagation();
    this.showMore.set(!this.showMore());
  }

  click(event: MouseEvent, element: any) {
    event.stopPropagation();
    if (this.settings().clickAction) {
      this.settings().clickAction(element);
    } else if (this.settings().toClipboardTranslator) {
      navigator.clipboard.writeText(this.settings().toClipboardTranslator(element)).then(
        () => this.snackbarService.success('copied to clipboard'),
        () => this.snackbarService.error('unable to copy to clipboard'),
      );
    }
  }

  deleteButtonClicked(event: MouseEvent, element: any) {
    event.stopPropagation();
    this.buttonClicked.emit({ type: 'delete', element });
  }

  editButtonClicked(event: MouseEvent, element: any) {
    event.stopPropagation();
    this.buttonClicked.emit({ type: 'edit', element });
  }

  addButtonClicked(event: MouseEvent) {
    event.stopPropagation();
    this.buttonClicked.emit({ type: 'add', element: null });
  }
}
